export const SEARCH__LOADING = "SEARCH::LOADING";
export const SEARCH__GET = "SEARCH::GET";
export const SEARCH__MORE = "SEARCH::MORE";
export const SEARCH_FIELD__TOGGLE = "SEARCH_FIELD::TOGGLE";
export const SEARCH_FIELD__SETVALUES = "SEARCH_FIELD::SETVALUES";
export const MAIN_MENU__TOGGLE = "MAIN_MENU__TOGGLE";
export const LANGUAGE_FIELD__TOGGLE = "LANGUAGE_FIELD::TOGGLE";

export const COOKIEBAR_COOKIE = "cookiebar/COOKIEBAR_COOKIE";
export const COOKIEBAR_COOKIE__SET = "cookiebar/COOKIEBAR_COOKIE_SET";
export const COOKIEBAR_COOKIE__CLEARALL = "cookiebar/COOKIEBAR_COOKIE_CLEARALL";

export const LISTPAGE__LOADING = "LISTPAGE::LOADING";
export const LISTPAGE__GETITEMS = "LISTPAGE::GETITEMS";
export const LISTPAGE__GETALLCATEGORIES = "LISTPAGE::GETALLCATEGORIES";
export const LISTPAGE__LOADINGCATEGORIES = "LISTPAGE::LOADINGCATEGORIES";
export const LISTPAGE__SETCATEGORIES = "LISTPAGE::SETCATEGORIES";
